import { Request as BaseRequest } from '../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: ['name'] as const,
	columnFields: ['name'] as const,
	standardFilterFields: ['franchiseId', 'countryCode'] as const,
	dateFilterFields: [] as const,
	stageStatusFilterFields: [] as const,
	booleanFilterFields: [] as const,
});
